import { Button, Modal } from "react-bootstrap";
import React, { VFC } from "react";

type ConfirmModalProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  func: () => void;
  confirmText: string;
  target: string;
};

const ConfirmModal: VFC<ConfirmModalProps> = ({
  show,
  setShow,
  func,
  confirmText,
  target
}) => {
  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{target}の実行</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{confirmText}</p>
        <p>よろしければ実行をクリックしてください。</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          中止
        </Button>
        <Button variant="primary" onClick={func}>
          実行
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
